import clsx from "clsx"
import React from "react"

const CurrentStepIndicator = ({
  stepsCount,
  currentStep,
  className,
}: {
  stepsCount: number
  currentStep: number
  className?: string
}) => {
  return (
    <div className={clsx("flex items-center gap-1", className)}>
      {Array.from({ length: stepsCount }, (_, i) => i).map(index => {
        if (index === 0) return
        return (
          <div
            key={index}
            className={clsx(
              "h-0.5 w-1 rounded-full bg-onSurface-300 transition-colors",
              {
                "bg-onSurface-900": currentStep === index,
              }
            )}
          />
        )
      })}
    </div>
  )
}

export default CurrentStepIndicator
